import type { ChangeEvent } from 'react';

import { MenuItem, Select, TextField } from '@mui/material';

import type { ExportSettingsType } from '@/features/DataHub/modules/Export/types';

import type { SelectChangeEvent } from '@mui/material/Select';

type RangePeriodFieldsProps = {
  periodNumber: string;
  period: ExportSettingsType['period'];
  periodNumberError: boolean;
  onChangePeriodNumber: (event: ChangeEvent<HTMLInputElement>) => void;
  onChangePeriod: (event: SelectChangeEvent<ExportSettingsType['period']>) => void;
  periodOptions?: Array<{ value: ExportSettingsType['period']; label: string }>;
};

const DEFAULT_PERIOD_OPTIONS: Array<{ value: ExportSettingsType['period']; label: string }> = [
  { value: 'd', label: 'Days' },
  { value: 'm', label: 'Months' },
  { value: 'y', label: 'Years' },
  { value: 'v', label: 'Values' }
];

export const PERIOD_OPTIONS_WITHOUT_VALUES: Array<{
  value: ExportSettingsType['period'];
  label: string;
}> = DEFAULT_PERIOD_OPTIONS.filter(o => o.value !== 'v');

export const RangePeriodFields = ({
  periodNumber,
  period,
  periodNumberError,
  onChangePeriodNumber,
  onChangePeriod,
  periodOptions = DEFAULT_PERIOD_OPTIONS
}: RangePeriodFieldsProps) => {
  return (
    <>
      <TextField
        error={periodNumberError}
        helperText={periodNumberError ? 'Please enter a valid number' : ''}
        size='small'
        slotProps={{
          htmlInput: {
            maxLength: 2,
            inputMode: 'numeric',
            'aria-label': 'Range period number'
          }
        }}
        sx={{
          ml: 2,
          width: 45,
          '& .MuiInputBase-input': {
            p: '7px 14px'
          },
          '.MuiFormHelperText-root': {
            position: 'absolute',
            ml: 0,
            bottom: '-22px',
            fontSize: '12px',
            width: 150
          }
        }}
        value={periodNumber}
        variant='filled'
        onChange={onChangePeriodNumber}
      />
      <Select
        MenuProps={{
          onClick: e => {
            e.preventDefault();
          },
          sx: { zIndex: 10000 }
        }}
        size='small'
        sx={{
          ml: 2,
          '& .MuiInputBase-input': {
            p: '5.5px 14px',
            backgroundColor: '#272d48'
          },
          '& .MuiMenu-paper': {
            top: '108px!important',
            left: '141px!important'
          }
        }}
        value={period}
        variant='filled'
        onChange={onChangePeriod}
      >
        {periodOptions.map(({ value, label }) => (
          <MenuItem
            key={value}
            sx={{ fontSize: '14px' }}
            value={value}
          >
            {label}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};
